export default "__VITE_ASSET__D0FY0X8u__"